import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Strengths from './components/Strengths';
import Services from './components/Services';
import ServiceArea from './components/ServiceArea';
import ContactForm from './components/ContactForm';
import CompanyInfo from './components/CompanyInfo';
import Recruitment from './components/Recruitment';
import Footer from './components/Footer';

const PHONE = '03-○○○○-○○○○';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Strengths />
        <Services />
        <ServiceArea />
        <ContactForm />
        <CompanyInfo />
        <Recruitment />
      </main>
      <Footer />

      <a
        href={`tel:${PHONE}`}
        className="fixed bottom-6 right-6 z-40 bg-[#38BDF8] hover:bg-[#7dd3fc] text-[#0D1A4E] w-14 h-14 flex items-center justify-center rounded-full cursor-pointer transition-colors"
        title="電話で問い合わせる"
      >
        <div className="w-7 h-7 flex items-center justify-center">
          <i className="ri-phone-fill text-2xl"></i>
        </div>
      </a>
    </div>
  );
}
